import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

const SECTIONS = [
  {
    title: "About This Website",
    body: [
      "This website is operated by Nurturing Happiness, an initiative focused on mental wellness, education, personal growth, positive living and stronger communities. By using this website, you agree to these Terms & Conditions.",
    ],
  },
  {
    title: "Purpose of the Content",
    body: [
      "The content on this website is provided for general educational and informational purposes. It is intended to encourage awareness, learning and positive living.",
      "The content is not a substitute for professional medical, psychological, educational or legal advice. If you are facing a mental health concern or any other serious issue, please seek support from a qualified professional.",
    ],
  },
  {
    title: "Use of the Website",
    body: [
      "You are welcome to read, share and reference the content of this website for personal, non-commercial and educational purposes, with appropriate credit to Nurturing Happiness.",
      "You agree not to misuse this website — for example, by attempting to disrupt its operation, submitting false or harmful content through the contact form, or misrepresenting the initiative.",
    ],
  },
  {
    title: "Intellectual Property",
    body: [
      "The Nurturing Happiness name, logo, artwork and the content of this website belong to Nurturing Happiness unless otherwise stated. Please contact us before reproducing substantial portions of the content for any public or commercial use.",
    ],
  },
  {
    title: "Accuracy of Information",
    body: [
      "We take care to keep the information on this website accurate and up to date, but we do not guarantee that all content is complete, current or free from error. The website is provided on an “as is” basis without warranties of any kind.",
    ],
  },
  {
    title: "External Links",
    body: [
      "This website may contain links to external services, such as map directions. We are not responsible for the content or practices of external websites.",
    ],
  },
  {
    title: "Contact Form",
    body: [
      "When you submit the contact form, you agree that the information you provide is accurate to the best of your knowledge and that we may use it to respond to your enquiry, as described in our Privacy Policy.",
    ],
  },
  {
    title: "Changes to These Terms",
    body: [
      "We may update these Terms & Conditions from time to time. Any updates will be published on this page and take effect when published.",
    ],
  },
  {
    title: "Contact Us",
    body: ["If you have any questions about these Terms & Conditions, please contact us:"],
    contact: true,
  },
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms & Conditions | Nurturing Happiness"
        description="The terms that govern the use of the Nurturing Happiness website."
      />
      <section data-testid="terms-page" className="paper-texture py-20 md:py-24">
        <div className="mx-auto max-w-3xl px-6">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-nh-green">Legal</p>
            <h1 className="mt-3 font-heading text-4xl font-bold tracking-tight text-nh-ink sm:text-5xl">
              Terms &amp; Conditions
            </h1>
            <p className="mt-4 text-sm text-nh-muted">Last updated: July 2026</p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s) => (
              <Reveal key={s.title}>
                <section>
                  <h2 className="font-heading text-xl font-bold text-nh-deep sm:text-2xl">{s.title}</h2>
                  {s.body.map((p, i) => (
                    <p key={i} className="mt-3 text-[15px] leading-relaxed text-nh-body md:text-base">
                      {p}
                    </p>
                  ))}
                  {s.contact && (
                    <div className="mt-4 rounded-2xl bg-nh-mint p-6 text-[15px] leading-relaxed text-nh-body">
                      <p className="font-semibold text-nh-deep">Nurturing Happiness</p>
                      <p>2nd Floor, Nishant Tower, MG Road, Akola, Maharashtra – 444001, India</p>
                      <p>
                        Phone:{" "}
                        <a href="tel:+919921193939" className="font-medium text-nh-green hover:underline">
                          +91 99211 93939
                        </a>
                      </p>
                      <p>
                        Email:{" "}
                        <a
                          href="mailto:nurturinghappiness2@gmail.com"
                          className="break-all font-medium text-nh-green hover:underline"
                        >
                          nurturinghappiness2@gmail.com
                        </a>
                      </p>
                    </div>
                  )}
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
